import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { ConfigurationState } from './configuration.state';
import { apiUrl, baseFeaturesUrl, climateSolutionsDomain } from './configuration.model';
import { ConfigurationActions } from './configuration.actions';

const initConfigurationState: ConfigurationState = {
  featuresBaseUri: apiUrl + baseFeaturesUrl,
};

export const configurationReducer: ActionReducer<ConfigurationState, Action> = createReducer(
  initConfigurationState,
  on(
    ConfigurationActions.useClimateSolutionsDomain,
    (state): ConfigurationState => ({
      ...state,
      featuresBaseUri: climateSolutionsDomain + baseFeaturesUrl,
    })
  )
);
